import { useCallback, useEffect, useState } from 'react'

import { useNotification } from '@fsg/gui-bits'

import { ENDPOINTS } from '@app/constants'

export function useGetEmbedUrl(accessToken: string) {
  const [embedUrl, setEmbedUrl] = useState<string>()
  const notification = useNotification()

  // We cannot use api/request.ts method as Next.js server forcing caching the response
  // Quicksight doesn't allow to use Dashboard URL twice
  // So custom fetch method is used here
  const getUrl = useCallback(async () => {
    try {
      const urlResponse = await getEmbedUrlRequest(ENDPOINTS.QUICKSIGHT, accessToken)
      setEmbedUrl(urlResponse.embedUrl)
    } catch (error: any) {
      notification.api.notify({
        message: `Error requesting embed URL: ${error.message}`,
        type: 'warning',
      })
    }
  }, [accessToken, notification.api])

  useEffect(() => {
    getUrl()
  }, [getUrl])

  return embedUrl
}

async function getEmbedUrlRequest(url: string, accessToken: string) {
  const result = await fetch(process.env.NEXT_PUBLIC_API_GATEWAY_BASE_URL + url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return (await result.json()) as { embedUrl: string }
}
